import { authApi, createParams } from './index';

export const getAttendance = async (request) => {
	try {
		const params = createParams(request);
		const { data } = await authApi.get('/portal/collection/attendance', {
			params,
		});

		return data;
	} catch (error) {
		console.error(error);
	}
};

export const postAttendance = async (request) => {
	try {
		// Validate required field
		if (!request?.body?.collectionId) {
			console.log('request', request);
			throw new Error('collectionId is required');
		}

		// Request body structure - exact format required by API
		const body = {
			id: request.body.id || 0,
			state: request.body.state || 'ATTENDANCE',
			startTime: request.body.startTime || '2025,09,16,0,0,0', // Format: "YYYY,MM,DD,H,M,S"
			endTime: request.body.endTime || '2025,09,16,0,0,0', // Format: "YYYY,MM,DD,H,M,S"
			faceId: request.body.faceId || 0,
			collectionId: request.body.collectionId,
		};

		const { data } = await authApi.post('/portal/collection/attendance', body);

		return data;
	} catch (error) {
		console.error('Failed to post attendance:', error);
		throw error;
	}
};

// 새로운 페이징 API 함수
export const fetchPagingUsers = async ({
	page = 1,
	pageSize = 20,
	targetDate,
	nameFilter,
	classFilter,
	token,
}) => {
	try {
		const params = {
			page,
			page_size: pageSize,
			target_date: targetDate,
		};

		// nameFilter가 있으면 params에 추가
		if (nameFilter && nameFilter.trim()) {
			params.name_filter = nameFilter.trim();
		}

		if (classFilter && classFilter.trim()) {
			params.class_filter = classFilter.trim();
		}

		const config = {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
				Accept: 'application/json',
			},
		};

		const response = await authApi.get('/portal/paging/users', config);
		return response.data;
	} catch (error) {
		console.error('Failed to fetch paging users:', error);
		throw error;
	}
};
